import axios from 'axios';
import { store } from 'store';
import { CLIENT_THEME } from 'utils/clientTheme';
import { hasAccessToMultipleCustomers } from 'utils/validators/role.validation';

import type { CustomerShiftConfigResponse } from 'store/customer-shift-config.slice';

interface CustomerShiftConfigRequest {
  custCode: string;
  customerId?: string;
}

const getCustomerShiftConfig = async (
  custCode: string,
  explicitAccessToken?: string,
  explicitCustomerId?: string
): Promise<CustomerShiftConfigResponse> => {
  const state = store.getState();
  const accessToken = explicitAccessToken ?? state.authReducer.accessToken;
  const role = state.authReducer.role;
  const customerId = explicitCustomerId ?? state.persistedReducer.customer.id;

  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_MANAGEMENT_API_URL ?? ''}/api/`,
    timeout: 8000,
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      'x-client-theme': CLIENT_THEME,
    },
    params: {
      ...(hasAccessToMultipleCustomers(role as any) && customerId
        ? { customerId }
        : {}),
    },
  });

  const payload: CustomerShiftConfigRequest = {
    custCode,
    ...(customerId ? { customerId } : {}),
  };

  const response = await axiosInstance.post<CustomerShiftConfigResponse>(
    'device/customer-shift-config',
    payload
  );

  return response.data;
};

export default { getCustomerShiftConfig };
